import React from 'react';
import { Flex } from 'grid-styled';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import RolesList from '../../routes/Administration/RolesList';
import AddEditRole from '../../routes/Administration/AddEditRole';
import PropTypes from 'prop-types';
import { withPermissions } from '../../components/HoC';

class Roles extends React.Component {
  static propTypes = {
    permissions: PropTypes.object,
  };

  render() {
    const {
      permissions: { canAdminMac },
    } = this.props;

    if (!canAdminMac) return <Redirect to="/properties" />;
    return (
      <Flex flexDirection="column">
        <Switch>
          <Route exact path={`/administration/roles`} render={() => <RolesList />} />
          <Route exact path={`/administration/roles/add`} render={() => <AddEditRole />} />

          <Route exact path={`/administration/roles/:roleId`} render={() => <AddEditRole editPage />} />
        </Switch>
      </Flex>
    );
  }
}

export default withPermissions(withRouter(Roles));
